<template>
  <div v-if="!endwith" class="input" :class="{'-row' : isRow}">
    <label for="input" class="input__label">{{placeholder}}</label>
    <input
      autocomplete="off"
      type="text"
      :required="required"
      :pattern="rule"
      :minlength="minlength"
      @keyup="changed"
      v-model.trim="val"
    />
  </div>
  <span v-else>{{endwith}}</span>
</template>

<script>
export default {
  props: {
    required: {
      type: Boolean,
      default: false
    },
    minlength: {
      type: Number,
      default: null
    },
    rule: {
      type: String,
      default: null
    },
    endwith: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    },
    isRow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value
    };
  },
  watch: {
    value: function(val) {
      this.val = val;
    }
  },
  methods: {
    changed: function(e) {
      if (!e.target.validity.valid) return;
      this.$emit("input", e.target.value);
      return e.target.value;
    }
  }
};
</script>
